import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, DialogTitle as MuiDialogTitle, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  onClose?: () => void;
}>;

const DialogTitle: React.FC<Props> = ({ children, onClose, ...other }: Props) => {
  return (
    <MuiDialogTitle {...other}>
      <Box position="relative" display="flex" alignItems="center">
        <Typography variant="subtitle1-medium" component="span">
          {children}
        </Typography>

        {onClose ? (
          <Box ml="auto" pl={2}>
            <IconButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        ) : null}
      </Box>
    </MuiDialogTitle>
  );
};

export { DialogTitle };
